export default __webpack_public_path__ + "static/media/down-arrow.64d82364.svg";